import type { CSSProperties } from "react";
import { E32 } from "./endesga32";
import type { Theme } from "./pixel";

// "Simple" panel styling — matches the bitmap design system used in
// the shop/inventory/NPC mockups (Shop and inventory system/tokens.css).
//
// Single 2px ink border, single offset bitmap shadow. Cleaner than
// `panelStyle()` from theme/styles.ts (which stacks multiple inset
// frames suited for older lobby/admin chrome).
//
// Use this on any new world surface — shop entries, NPC dialogue,
// inventory grid, daily-challenge panel.

export function simplePanelStyle(theme: Theme): CSSProperties {
  return {
    background: theme.panelSolid,
    color: theme.ink,
    border: `2px solid ${theme.panelEdgeStrong}`,
    boxShadow: `4px 4px 0 0 ${E32.ink}`,
  };
}

// Smaller offset for nested panels.
export function simpleInnerPanelStyle(theme: Theme): CSSProperties {
  return {
    background: theme.panelSolid,
    color: theme.ink,
    border: `2px solid ${theme.panelEdgeStrong}`,
    boxShadow: `2px 2px 0 0 ${E32.ink}`,
  };
}
